import React from 'react';
import Anchor from '../Anchor';

const TextBlock = ({ title, content, anchor, background, gold }) => {
    const sectionStyle = background ? { background } : {};
    const sectionClass = gold ? "text-block gold" : "text-block";

    return (
        <Anchor anchor={anchor}>
            <section className={sectionClass} style={sectionStyle}>
                {title && <h3>{title}</h3>}
                {content && <p>{content}</p>}
            </section>
        </Anchor>
    );
}

export default TextBlock;